import axios from 'helpers/axios';
import config from '../../config';

const fetchEmailTemplatesRequest = () =>
  axios({
    method: 'get',
    url: `${config.apiUrl}/emailTemplates`,
  });

const fetchLogoRequest = ({ projectId }) =>
  axios({
    method: 'get',
    url: `${config.apiUrl}/get_email_image_data_project/${projectId}`,
  });

const uploadLogoRequest = (file) => {
  const formData = new FormData();
  formData.append('image', file);
  return axios({
    method: 'post',
    url: `${config.apiUrl}/imageUpload`,
    data: formData,
  });
};

const deleteLogoRequest = ({ id, projectId }) =>
  axios({
    method: 'delete',
    url: `${config.apiUrl}/delete_image_project/${id}/${projectId}`,
  });

const connectImageToProjectRequest = ({ projectId, fileUrl }) => {
  const formData = new FormData();
  formData.append('projectId', projectId);
  formData.append('fileUrl', fileUrl);

  return axios({
    method: 'post',
    url: `${config.apiUrl}/connect_image_to_project`,
    data: formData,
  });
};

const sendEmailsRequest = (data) =>
  axios({
    method: 'post',
    url: `${config.apiUrl}/applications/respond`,
    data: {
      category: data.category,
      applicationIds: data.recepients.map((application) => application.id),
      senderName: data.senderName,
      senderEmail: data.senderEmail,
      body: data.body,
      subject: data.subject,
      positionName: data.positionName,
      logoPath: data.logoPath,
      projectId: data.projectId,
      scheduled: data.scheduled,
    },
  });

export {
  connectImageToProjectRequest,
  deleteLogoRequest,
  fetchEmailTemplatesRequest,
  fetchLogoRequest,
  sendEmailsRequest,
  uploadLogoRequest,
};
